import React from 'react';

function SealSuccess() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.61078 1.10194C5.63384 0.785688 4.57182 1.22559 4.10463 2.14003L3.54297 3.23938C3.47624 3.37 3.37 3.47624 3.23938 3.54297L2.14003 4.10463C1.22559 4.57182 0.785688 5.63384 1.10194 6.61078L1.48215 7.78529C1.52732 7.92484 1.52732 8.07512 1.48215 8.21466L1.10194 9.38917C0.785688 10.3661 1.22559 11.4281 2.14003 11.8954L3.23938 12.457C3.37 12.5237 3.47624 12.63 3.54297 12.7606L4.10463 13.86C4.57182 14.7744 5.63384 15.2143 6.61078 14.8981L7.78529 14.5178C7.92484 14.4727 8.07512 14.4727 8.21466 14.5178L9.38917 14.8981C10.3661 15.2143 11.4281 14.7744 11.8954 13.86L12.457 12.7606C12.5237 12.63 12.63 12.5237 12.7606 12.457L13.86 11.8954C14.7744 11.4281 15.2143 10.3661 14.8981 9.38917L14.5178 8.21466C14.4727 8.07512 14.4727 7.92484 14.5178 7.78529L14.8981 6.61078C15.2143 5.63384 14.7744 4.57182 13.86 4.10463L12.7606 3.54297C12.63 3.47624 12.5237 3.37 12.457 3.23938L11.8954 2.14003C11.4281 1.22559 10.3661 0.785688 9.38917 1.10194L8.21466 1.48215C8.07512 1.52731 7.92484 1.52732 7.78529 1.48215L6.61078 1.10194ZM4.34734 7.83081L5.33311 6.84499L7.30461 8.81656L11.2477 4.87352L12.2334 5.85928L7.30461 10.7881L4.34734 7.83081Z"
        fill="#00A331"
      />
    </svg>
  );
}

export default SealSuccess;
